import { LayoutActionTypes } from "./types";

export const changeTab = (layoutMode: any) => ({
  type: LayoutActionTypes.CHANGE_TAB,
  payload: layoutMode,
});

export const changelayoutMode = (layoutMode: any) => ({
  type: LayoutActionTypes.CHANGE_LAYOUT_MODE,
  payload: { layoutMode },
});

export const setIsInFrame = (isInFrame: boolean) => ({
  type: LayoutActionTypes.SET_IS_IN_FRAME,
  payload: { isInFrame }
})

export const setGlobalError = (errorMsg: string) => ({
  type: LayoutActionTypes.SET_GLOBAL_ERROR,
  payload: errorMsg
});

export const setPermNotification = (isGrant: boolean | undefined) => ({
  type: LayoutActionTypes.SET_PERM_NOTIFICATION,
  payload: isGrant
});

export const setApprovalPendingCount = (count: number) => ({
  type: LayoutActionTypes.SET_APPROVAL_PENDING_COUNT,
  payload: count
});

export const bumpApprovalListChanged = () => ({
  type: LayoutActionTypes.BUMP_APPROVAL_LIST_CHANGED,
});

export const SET_FRAME_VALUE = () => ({
  type: LayoutActionTypes.SET_FRAME_VALUE,
  payload: {}
});

export const setViewpostSize = (width: number, size: "xs" | "sm" | "md" | "lg" | "xl" | "xxl") => ({
  type: LayoutActionTypes.SET_VIEWPOST_SIZE,
  payload: { width, size }
})